import { render, staticRenderFns } from "./sedesBySucursal.vue?vue&type=template&id=a2c15938"
import script from "./sedesBySucursal.vue?vue&type=script&lang=js"
export * from "./sedesBySucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports